"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("components");

var _uiAtoms = require("egov-ui-framework/ui-atoms");

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

var _logoImage = require("egov-ui-kit/assets/images/logoImage.png");

var _logoImage2 = _interopRequireDefault(_logoImage);

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectedLabelStyle = {
  color: "#ffffff"
};

var selectedStyle = {
  backgroundColor: "#f06f00",
  border: "1px solid #f06f00"
};

var defaultStyle = {
  border: "1px solid #484848",
  borderRadius: "1px",
  marginRight: "4.65%",
  height: "44px",
  lineHeight: "44px",
  width: "28.48%",
  padding: "0 16px"
};

var defaultLabelStyle = {
  textTransform: "none",
  fontWeight: "500",
  color: "#484848",
  verticalAlign: "initial",
  padding: 0
};

var LanguageSelectionForm = function LanguageSelectionForm(_ref) {
  var items = _ref.items,
      onLanguageSelect = _ref.onLanguageSelect,
      value = _ref.value,
      onClick = _ref.onClick,
      logoUrl = _ref.logoUrl;

  console.log("logoUrl", logoUrl);
  return _react2.default.createElement(_components.Card, {
    className: "col-sm-offset-4 col-sm-4 user-screens-card language-selection-card",
    textChildren: _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "div",
        { className: "rainmaker-displayInline login-form-screen", style: { justifyContent: "center", alignItems: "center", marginBottom: "24px" } },
        _react2.default.createElement(
          "div",
          { className: "" },
          _react2.default.createElement(_components.Image, { className: "mseva-logo"
            // source={logoUrl?logoUrl:logo} 
            , source: _logoImage2.default
          })
        ),
        _react2.default.createElement(
          "div",
          { style: { marginTop: "16px" } },
          _react2.default.createElement(_translationNode2.default, { bold: true, color: "black", fontSize: "24px"
            // label="STATE_LABEL"
            , label: "SUDM Uttar Pradesh",
            className: "login-title-heading" })
        )
      ),
      _react2.default.createElement(
        "form",
        null,
        _react2.default.createElement(
          "div",
          { className: "button-toggle-container button-language-selection-toggle" },
          _react2.default.createElement(_components.ButtonGroup, {
            items: items,
            onClick: onClick,
            selected: value,
            defaultStyle: defaultStyle,
            defaultLabelStyle: defaultLabelStyle,
            selectedStyle: selectedStyle,
            selectedLabelStyle: selectedLabelStyle,
            multiple: false
          })
        ),
        _react2.default.createElement(
          "div",
          { className: "button-container" },
          _react2.default.createElement(
            _uiAtoms.Button,
            {
              id: "continue-action",
              className: "lang-continue-button common-all-btn",
              style: {
                height: "48px",
                width: "100%"
              },
              variant: "contained",
              color: "primary",
              onClick: onLanguageSelect
            },
            _react2.default.createElement(_translationNode2.default, { buttonLabel: true, labelStyle: { fontWeight: 500 }
              // label="CORE_COMMON_CONTINUE" 
              , label: "CONTINUE"
            })
          )
        )
      )
    )
  });
};

exports.default = LanguageSelectionForm;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/User/components/LanguageSelectionForm/index.js
// module id = ../lib/egov-ui-kit/common/User/components/LanguageSelectionForm/index.js
// module chunks = 504